export const environment = {
  production: true,
  apiUrl: 'https://atspeed-sabiq-console.online/api'
};
